<div [formGroup]="group" class="form-group">
    <label [for]="fcName+i" class="label-info">{{textLabel}}</label>
    <div class="input-group mb-2">
        <input [formControlName]="fcName" [id]="fcName+i"
               [min]="min"
               [name]="fcName + i"
               [ngClass]="{'is-invalid': (control.dirty || control.touched) && control.invalid}"
               class="form-control"
               type="number">
    </div>
</div>
